import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { bool, func, string } from 'prop-types';
import { Grid } from '@material-ui/core';
import { Formik } from 'formik';
import i18next from 'i18next';

import Modal from '~/components/Modal';
import TextInput from '~/components/TextInput';
import { SecondaryButton, PrimaryButton } from '~/components/Button';
import DocumentActions from '~/store/ducks/documents';
import AttachFile from '../components/AttachFile';

import schema from './validationSchema';

import { Container, WrapperTop, ErrorMessage } from './styles';

const CreateNewDocument = ({ open, folderId, onClose }) => {
  const dispatch = useDispatch();
  const [document, setDocument] = useState(null);
  const [error, setError] = useState(false);

  function reloadDocuments() {
    dispatch(DocumentActions.getFolderDetailsRequest(folderId));
    dispatch(DocumentActions.getMyDocumentsRequest(folderId));
    dispatch(DocumentActions.getFoldersRequest());
  }

  function submit(values) {
    if (document) {
      dispatch(
        DocumentActions.createNewDocumentRequest(
          values.title,
          folderId,
          document,
          reloadDocuments
        )
      );
      onClose();
    } else {
      setError(true);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={i18next.t('documents.newDocumentModal.title')}
      noPadding
    >
      <Container>
        <Formik
          initialValues={{
            title: '',
          }}
          onSubmit={submit}
          validationSchema={schema}
        >
          {({ values, touched, errors, handleChange, handleSubmit }) => (
            <>
              <WrapperTop>
                <Grid container spacing={2}>
                  <Grid item xs>
                    <TextInput
                      label={i18next.t(
                        'documents.newDocumentModal.nameInstruction'
                      )}
                      placeholder={i18next.t(
                        'documents.newDocumentModal.placeholder'
                      )}
                      name="title"
                      value={values.title}
                      touched={touched.title}
                      error={errors.title}
                      onChange={handleChange}
                      onSubmit={handleSubmit}
                    />
                  </Grid>
                </Grid>
              </WrapperTop>
              {error && (
                <ErrorMessage>
                  {i18next.t('documents.newDocumentModal.error')}
                </ErrorMessage>
              )}
              <AttachFile setDocument={setDocument} setError={setError} />

              <Grid container spacing={3} justify="center">
                <Grid item xs={12} md={6} lg={4}>
                  <SecondaryButton
                    label={i18next.t('common.buttons.cancel')}
                    type="secondary"
                    onClick={onClose}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <PrimaryButton
                    label={i18next.t('common.buttons.add')}
                    type="submit"
                    onClick={handleSubmit}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Formik>
      </Container>
    </Modal>
  );
};

export default CreateNewDocument;

CreateNewDocument.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  folderId: string.isRequired,
};
